import * as React from 'react'

import { Table } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import usePagination from 'modules/core/hooks/usePagination'
import i18n from 'modules/core/lib/i18n'

import { type ContractVersions } from 'modules/contracts/store/collections/contractVersions'
import Item from 'modules/employees/components/EmployeesList/components/_ListEmployees/_Body/_Item'
import type Employee from 'modules/employees/store/models/Employee'

interface Props {
  canBulkEdit: boolean
  employees: Employee[]
  selectedEmployeesIds: number[]
  onSelectEmployee: (employee: Employee, value: boolean) => void
  contractVersions: ContractVersions
}

const GroupBody = ({
  canBulkEdit,
  employees,
  selectedEmployeesIds,
  onSelectEmployee,
  contractVersions,
}: Props) => {
  const { paginatedItems, loadMore, hasMore, page } = usePagination({
    batchSize: 50,
    items: employees,
  })

  if (employees.length === 0) {
    return (
      <Table.Body>
        <Table.Blank colSpan={12} text={i18n.t('employees.no_employees_found')} />
      </Table.Body>
    )
  }

  return (
    <Table.BodyWithInfiniteScroll page={page} loadMore={loadMore} hasMore={hasMore} colSpan={12}>
      <Table noRadius hideBorder fullWidth>
        {paginatedItems.map((employee, index) => (
          <Item
            canBulkEdit={canBulkEdit}
            key={employee.id}
            position={index}
            employee={employee}
            selectedEmployeesIds={selectedEmployeesIds}
            onSelectEmployee={onSelectEmployee}
            contractVersions={contractVersions}
          />
        ))}
      </Table>
    </Table.BodyWithInfiniteScroll>
  )
}

export default observer(GroupBody)
